import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Platform} from "ionic-angular";
import {Observable} from "rxjs";
import {AppVersion} from "@ionic-native/app-version";
import {LocalStorageWrapper} from "../local-storage-wrapper/local-storage-wrapper";

/*
  Generated class for the ApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiProvider {

  chatHost: String = 'https://chat.app.nach-dem-fasten.de'
  host: String = 'https://backend.app.nach-dem-fasten.de/api';
  refreshTokenInProgress: boolean = false;
  version: string = '';
  refreshCount: number = 0;

  constructor(public http: HttpClient, public platform: Platform, private appVersion: AppVersion, public localStorage: LocalStorageWrapper) {
    if((window.location.hostname == 'localhost' || window.location.hostname == 'work' || window.location.hostname.indexOf('work.') === 0|| window.location.hostname.indexOf('192.168') > -1) && (this.platform.is('mobileweb') || this.platform.is('core'))) {
      this.host = 'http://'+window.location.hostname+':5741/api';
      this.chatHost = 'http://'+window.location.hostname+':8011';
    }

    if(this.localStorage.getItem('overWrittenApiHost')) {
      console.log('using overwritten api host!')
      this.host = this.localStorage.getItem('overWrittenApiHost');
    }

    if(this.localStorage.getItem('appVersion')) {
      this.version = this.localStorage.getItem('appVersion');
    }

    this.platform.ready().then(() => {
      this.appVersion.getVersionCode().then(val => {
        this.version = val.toString();
        this.localStorage.setItem('appVersion', val.toString());
      }).catch(err => {
        console.log("get version code error",err)
      })
    })
  }

  private handleTokenRefresh<T>(result: Observable<T>, method: string, endpoint: string, data?: any) {
    var me = this;

    console.log(this.localStorage.getItem('api_token')?('Bearer '+this.localStorage.getItem('api_token')):'')
    return new Observable<T>(observer => {
      result.subscribe((res: T) => {
        observer.next(res)
        observer.complete();
      }, (err: any) => {
        if(err instanceof HttpErrorResponse) {
          if(err.status != 401 || me.refreshTokenInProgress || this.refreshCount > 10) {
            observer.error(err);
          } else {
            this.refreshCount++;
            me.tryToRefreshToken().subscribe((success: any) => {
              let dateLog = new Date().toISOString();
              window.localStorage.setItem('videa-mellitus_log_refresh_'+dateLog, 'OLD: '+this.localStorage.getItem('api_token')+" NEW:"+success.token)
              this.localStorage.setItem('api_token', success.token);
              this.localStorage.setItem('api_refresh', success.refresh_token);
              me[method](endpoint, data).subscribe((res: T) => {
                observer.next(res)
                observer.complete()
              }, (err: any) => {
                observer.error(err);
              });
              me.refreshTokenInProgress = false;
            }, (err: any) => {
              observer.error(err);
            });
          }
        }
      });
    }, );
  }

  callGet<T>(endpoint: string, data?: any) {
    var result = this.http.get<T>(
      this.host+endpoint,
      {
        params: data,
        headers: {
          Client: this.version,
          Accept: 'application/json',
          Authorization: this.localStorage.getItem('api_token')?('Bearer '+this.localStorage.getItem('api_token')):'',
        }
      }
    )

    return this.handleTokenRefresh<T>(result, 'callGet', endpoint, data);
  }

  callPost<T>(endpoint: string, data?: any) {
    var result = this.http.post<T>(this.host+endpoint, data,
      {
        headers: {
          Client: this.version,
          Accept: 'application/json',
          Authorization: this.localStorage.getItem('api_token')?('Bearer '+this.localStorage.getItem('api_token')):'',
        }
      })

    return this.handleTokenRefresh<T>(result, 'callPost', endpoint, data);
  }

  callPut<T>(endpoint: string, data?: any) {
    var result = this.http.put<T>(this.host+endpoint, data,
      {
        headers: {
          Client: this.version,
          Accept: 'application/json',
          Authorization: this.localStorage.getItem('api_token')?('Bearer '+this.localStorage.getItem('api_token')):'',
        }
      });
    return this.handleTokenRefresh<T>(result, 'callPut', endpoint, data);
  }

  callPatch<T>(endpoint: string, data?: any) {
    var result = this.http.patch<T>(this.host+endpoint, data,
      {
        headers: {
          Client: this.version,
          Authorization: this.localStorage.getItem('api_token')?('Bearer '+this.localStorage.getItem('api_token')):'',
        }
      });
    return this.handleTokenRefresh<T>(result, 'callPatch', endpoint, data);
  }

  tryToRefreshToken() {
    this.refreshTokenInProgress = true;
    return this.http.post(this.host+'/login_refresh', {refresh_token: this.localStorage.getItem('api_refresh')});
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts